import { Injectable } from '@angular/core';
//Format Time with momentJS
import * as moment from 'moment'

@Injectable({
  providedIn: 'root'
})
export class FormatDataService {

  constructor() { }

  validatePunchInput(date, hour, minute) {
    var year = parseInt(date.substring(6, 10));
    var month = parseInt(date.substring(0, 2));
    var day = parseInt(date.substring(3, 5));

    var formatNumber = function (number) {
      if (parseInt(number) < 10) {
        return '0' + number.toString();
      } else {
        return number.toString();
      }
    }

    return year + '-' + formatNumber(month) + '-' + formatNumber(day) + 'T' + formatNumber(hour) + ':' + formatNumber(minute) + ':00Z'
  }

  getEndDateForCalendar() {
    let todayDate = moment().format('MM/DD/YYYY');
    var year = parseInt(todayDate.substring(6, 10));
    var month = parseInt(todayDate.substring(0, 2));
    var day = parseInt(todayDate.substring(3, 5));
    return {
      year: year,
      month: month,
      day: day
    }
  }

  getStartDateForCalendar() {
    let todayDate = moment().subtract(30, 'days').format('MM/DD/YYYY');
    var year = parseInt(todayDate.substring(6, 10));
    var month = parseInt(todayDate.substring(0, 2));
    var day = parseInt(todayDate.substring(3, 5));
    return {
      year: year,
      month: month,
      day: day
    }
  }

  formatPayPeriodToWeekEndingDate(datetime) {
    var year = datetime.substring(19, 23);
    var month = datetime.substring(13, 15);
    var day = datetime.substring(16, 18);
    return year + "-" + month + "-" + day;
  }

  formatPunchToSubmit(date, punchHour, punchMinute) {
    var year = date.substring(6, 10);
    var month = date.substring(0, 2);
    var day = date.substring(3, 5);

    var formatNumber = function (number) {
      if (parseInt(number) < 10) {
        return '0' + number.toString();
      } else {
        return number.toString();
      }
    }

    var punchTime = formatNumber(punchHour) + ':' + formatNumber(punchMinute);

    return year + '-' + month + '-' + day + 'T' + punchTime + ':00.000Z';
  }

  //Start get hours for each punch in and out
  getPunchHours(date, punchInHour, punchInMinute, punchOutHour, punchOutMinute) {
    var year = date.substring(6, 10);
    var month = date.substring(0, 2);
    var day = date.substring(3, 5);

    var formatNumber = function (number) {
      if (parseInt(number) < 10) {
        return '0' + number.toString();
      } else {
        return number.toString();
      }
    }

    var start = moment(year + '-' + month + '-' + day + 'T' + formatNumber(punchInHour) + ':' + formatNumber(punchInMinute) + ':00.000');
    var end = moment(year + '-' + month + '-' + day + 'T' + formatNumber(punchOutHour) + ':' + formatNumber(punchOutMinute) + ':00.000');
    var duration = moment.duration(start.diff(end));
    return duration.asHours();
  }

  getPunchHoursForDetailsPage(punchIn, punchOut) {
    var duration = moment.duration(moment(punchIn).diff(moment(punchOut)));
    return parseFloat(Math.abs(duration.asHours()).toFixed(2));
  }

  formatSelectedWeekToSubmit(date) {
    return date.substring(13, 23)
  }

  formatDateForValidation(date) {
    var year = date.year;
    var month = date.month;
    var day = date.day

    var formatNumber = function (number) {
      if (parseInt(number) < 10) {
        return '0' + number.toString();
      } else {
        return number.toString();
      }
    }

    return year + '-' + formatNumber(month) + '-' + formatNumber(day);
  }

  createDaysOfPayWeek(date, isWeekly) {
    if (isWeekly == true) {
      return [
        moment(this.formatPayPeriodToWeekEndingDate(date)).format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(1, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(2, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(3, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(4, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(5, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(6, 'days').format('MM/DD/YYYY')
      ]
    } else {
      return [
        moment(this.formatPayPeriodToWeekEndingDate(date)).format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(1, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(2, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(3, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(4, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(5, 'days').format('MM/DD/YYYY'),
        moment(this.formatPayPeriodToWeekEndingDate(date)).subtract(6, 'days').format('MM/DD/YYYY'),
      ]
    }
  }

  formatDateYyyyMmDd(datetime) {
    var year = datetime.substring(0, 4);
    var month = datetime.substring(5, 7);
    var day = datetime.substring(8, 10);
    return year + "-" + month + "-" + day;
  }

  formatDateMmDdYyyy(datetime) {
    var year = datetime.substring(0, 4);
    var month = datetime.substring(5, 7);
    var day = datetime.substring(8, 10);
    return month + "-" + day + "-" + year;
  }

  formatDateYyyyMmDdReverse(date) {
    var year = date.substring(6, 10);
    var month = date.substring(0, 2);
    var day = date.substring(3, 5);
    return year + "-" + month + "-" + day;
  }


  formatDateForCalendar(date) {
    return date.month + '-' + date.day + '-' + date.year
  }

  formatMinutesToHours(minutes) {
    var minutes = minutes;
    var hours = (minutes / 60);
    return hours;
  }

  formatTime(time) {
    const meridian = time.hour < 12 ? 'AM' : 'PM';
    let timeStr = '';
    if (time.hour < 10 || (time.hour > 12 && time.hour < 22)) {
      if (time.hour === 0) {
        timeStr += '12';
      } else {
        timeStr += '0';
        if (time.hour > 12) {
          const fixedHour = time.hour - 12;
          timeStr += fixedHour;
        } else {
          timeStr += time.hour;
        }
      }
    } else {
      if (time.hour > 12) {
        const fixedHour = time.hour - 12;
        timeStr += fixedHour;
      } else {
        timeStr += time.hour;
      }
    }
    timeStr += ':';
    if (time.minute > 9) {
      timeStr += time.minute;
    } else {
      timeStr += '0' + time.minute;
    }
    timeStr += ' ' + meridian;
    return timeStr;
  }

  formatScheduleTime(date, clockInTime, clockOutTime) {
    if (date !== undefined && date !== null && clockInTime !== null && clockOutTime !== null) {
      const clockOutDay = {
        day: date.day,
        month: date.month,
        year: date.year
      };

      const d = new Date(date.year, date.month - 1, date.day);

      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear() + ' from ' + this.formatTime(clockInTime) + ' to ' + this.formatTime(clockOutTime);
    }
    return null;
  }
}
